import React, { Fragment } from 'react';
import { GetApp as GetAppIcon } from '@mui/icons-material';
import { SubmitIconButton } from '@homesusa/core';
import { GridTableContext } from '../contexts';
import { getSortColumn } from '../utils';
import { exportXlsx } from '../utils/export-xlsx';

interface ExportButtonsProps<D = any> {
  onClick: (sortBy?: string) => Promise<D[]>;
  fileName: string;
}

export function ExportButtons({ onClick, fileName }: ExportButtonsProps): JSX.Element {
  const { instance, columnsOrder } = React.useContext(GridTableContext);

  const visibleColumns = columnsOrder.filter((col) => col.isVisible);
  const sortColumn = getSortColumn(instance.state.sortBy);

  return (
    <Fragment>
      <SubmitIconButton
        onClick={async (): Promise<void> => {
          return onClick(sortColumn).then((data) => {
            exportXlsx({
              columns: visibleColumns,
              data,
              fileName
            });
          });
        }}
        buttonProps={{
          sx: { borderRadius: 0, background: 'inherit' }
        }}
        title='Export as XLSX'
      >
        <GetAppIcon />
      </SubmitIconButton>
    </Fragment>
  );
}
